import { render, staticRenderFns } from "./helpcenterimageUploader.vue?vue&type=template&id=40e288b7&scoped=true"
import script from "./helpcenterimageUploader.vue?vue&type=script&lang=js"
export * from "./helpcenterimageUploader.vue?vue&type=script&lang=js"
import style0 from "./helpcenterimageUploader.vue?vue&type=style&index=0&id=40e288b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e288b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
